<template>
  <el-row type="flex" class="row-bg">
    <!-- record 需註解 -->
    <!-- <el-col :span="2">
      <div><router-link to="/">Home</router-link></div>
      <div><router-link to="/about">About</router-link></div>
    </el-col> -->
    <el-col :span="24"><router-view/></el-col>
  </el-row>
</template>

<style lang="scss">
.el-col{
  min-height: 100vh;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>